import { render, staticRenderFns } from "./EmpresaDetalhes.vue?vue&type=template&id=55d46ef8&scoped=true"
import script from "./EmpresaDetalhes.vue?vue&type=script&lang=js"
export * from "./EmpresaDetalhes.vue?vue&type=script&lang=js"
import style0 from "./EmpresaDetalhes.vue?vue&type=style&index=0&id=55d46ef8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d46ef8",
  null
  
)

export default component.exports